
import { mapGetters } from "vuex";

export default {
  props: {
    open: { type: Boolean, default: false },
    selectedVariant: { type: Object, default: () => {} },
  },

  data() {
    return {
      active: this.open,
      deliveryOptions: [],
      loading: false,
      postcode: "",
      suburb: "",
      errors: [],
    };
  },

  computed: {
    ...mapGetters("bag", ["isSnoozeMember"]),
    leadTimeText() {
      return this.selectedVariant?.lead_time_text;
    },
  },

  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.active = false;
      }
    },
    open(val) {
      this.active = val;
    },
    selectedVariant(newVal, oldVal) {
      if (this.postcode != "") {
        this.getDeliveryData(this.postcode);
      }
    },
  },

  methods: {
    onSearchStart() {
      this.errors = [];
      this.deliveryOptions = [];
    },
    async checkDelivery({ suburb = "", postcode = "" } = {}) {
      this.loading = true;
      this.postcode = postcode;
      this.suburb = suburb;

      try {
        this.deliveryOptions = await this.getDeliveryData(postcode);
      } catch (err) {
        this.$bugsnag.notify(err);
        this.errors.push("Something went wrong...");
        this.deliveryOptions = [];
      } finally {
        this.loading = false;
      }
    },
    async getDeliveryData(deliveryPostcode) {
      const weight = this.selectedVariant?.weight;
      const weightUnit = this.selectedVariant.weightUnit;
      const body = {
        is_member: this.isSnoozeMember,
        postcode: deliveryPostcode,
        suburb: this.suburb,
        items: [
          {
            sku: this.selectedVariant.sku,
            grams: weight * (weightUnit == "KILOGRAMS" ? 1000 : 1),
            price: Math.trunc(Number(this.selectedVariant.price) * 100),
            quantity: 1,
          },
        ],
      };

      const { data } = await this.$axios.post(
        `${this.$config.snoozeEcom}/shipping-simple`,
        body
      );
      const deliveryOptions = (data?.rates ?? []).filter(
        item => item.service_name !== "Store will confirm delivery cost"
      );

      return deliveryOptions.length === 0
        ? [
            {
              description:
                "Pickup your order when it is available from a Snooze store of your choice.",
              service_code: "CUSTPICKUP",
              service_name: "Pickup",
              store: null,
              total_price: 0,
            },
          ]
        : deliveryOptions;
    },
  },
};
